import { BadgeColorTheme } from '~/components/Badge/types';

export const UserTypeBadgeColorMap: { [key: string]: BadgeColorTheme } = {
  Admin: 'red',
  Agent: 'tertiary',
};
